import React__default, { useRef, useState, useEffect } from 'react';
import classnames from 'classnames';
import useWindowSize from '../../hooks/useWindowSize/index.js';
import useScroll from '../../hooks/useScroll/index.js';
import { Direction } from '../../hooks/useScroll/constants.js';
import styles from './Banner.module.css.js';
import { LARGE_SCREEN, COLLAPSED_SIZE } from './constants.js';

/* eslint-disable react-hooks/exhaustive-deps */
const Banner = ({ children, type, collapsedContent }) => {
    const bannerRef = useRef(null);
    const expandedRef = useRef(null);
    const [isCollapsing, setCollapsing] = useState(false);
    const [bannerHeight, setBannerHeight] = useState(0);
    const size = useWindowSize();
    const { scrollPosition, scrollDirection } = useScroll();
    const { UP, DOWN } = Direction;
    const checkCanScroll = () => {
        const documentHeight = Math.max(document.body.scrollHeight, document.documentElement.scrollHeight);
        const scrollDistanceAvailable = documentHeight - size.height;
        return scrollDistanceAvailable >= bannerHeight - COLLAPSED_SIZE;
    };
    const [canScroll, setCanScroll] = useState(checkCanScroll());
    const [canCollapse, setCanCollapse] = useState(size?.breakpoint !== LARGE_SCREEN &&
        typeof collapsedContent !== "undefined");
    const getCurrentHeight = () => {
        if (expandedRef.current) {
            return expandedRef.current.getBoundingClientRect().height;
        }
        return null;
    };
    const setUpBanner = (height) => {
        if (bannerRef.current) {
            bannerRef.current.style.height = height + "px";
            const heightDiference = height - COLLAPSED_SIZE;
            bannerRef.current.style.top = heightDiference * -1 + "px";
            setBannerHeight(height);
        }
    };
    useEffect(() => {
        const height = getCurrentHeight();
        if (height) {
            setUpBanner(height);
        }
        setCanScroll(checkCanScroll());
    }, []);
    useEffect(() => {
        const height = getCurrentHeight();
        if (height) {
            setUpBanner(height);
        }
        setCanCollapse(size?.breakpoint !== LARGE_SCREEN &&
            typeof collapsedContent !== "undefined");
        setCanScroll(checkCanScroll());
    }, [size, collapsedContent, canScroll]);
    useEffect(() => {
        if (!canCollapse || !canScroll) {
            setCollapsing(false);
            return;
        }
        if (scrollDirection === DOWN && !isCollapsing) {
            setCollapsing(true);
        }
        if (scrollDirection === UP && scrollPosition === 0 && isCollapsing) {
            setCollapsing(false);
        }
    }, [DOWN, UP, canCollapse, isCollapsing, scrollDirection, scrollPosition]);
    const className = classnames(styles.Banner, {
        [styles[`Banner__${type}`]]: type,
    });
    const notCollapsibleClassNames = classnames(styles.Banner__not_collapsible, {
        [styles[`Banner__${type}`]]: type,
    });
    const attributes = {
        className,
    };
    return (React__default.createElement(React__default.Fragment, null,
        (!canCollapse || !canScroll) && (React__default.createElement("div", { className: notCollapsibleClassNames }, children)),
        canCollapse && canScroll && (React__default.createElement("div", { ref: bannerRef, ...attributes },
            React__default.createElement("div", { className: styles.Banner__collapsed },
                !isCollapsing && (React__default.createElement("div", { className: styles.Banner_inner_container, ref: expandedRef }, children)),
                isCollapsing && (React__default.createElement("div", { className: styles.Banner__collapsed_content }, collapsedContent)))))));
};

export { Banner };
//# sourceMappingURL=Banner.js.map
